import * as Sentry from '@sentry/react'
import axios from 'axios'

import { helpers, httpStatuses } from '@reveni-io/reveni-ui'

import { navigateTo } from './helpers/location/location'
import { isTokenExpired, replaceAmountParam } from './helpers'
import { i18nInstance } from '.'

export const sendErrorToSentry = err => {
  if (import.meta.env.VITE_SENTRY_ENVIRONMENT && err.response) {
    let url = err.response?.request?.responseURL?.replace(/(\w){32}/g, ':uuid')
    url = replaceAmountParam(url)

    const newError = new Error(url)

    newError.name = `Error ${err.response?.status}: ${url}`
    newError.stack = `Error ${err.response?.status}: ${url}`

    Sentry.captureException(newError, {
      extra: {
        body: err.request?.__sentry_xhr__,
        localStorage: localStorage,
        response: err.response.data,
        responseString: JSON.stringify(err.response.data),
      },
    })
  }
}

export const getTokenAndSaveInLocalStorage = headers => {
  try {
    if (headers['x-customer-token']) {
      localStorage.jwt = headers['x-customer-token']
    }
    // eslint-disable-next-line
  } catch {} //without catch because is to handle errors if the user is in iframe and incognito mode active.
}

export const addJwtToAuthorizationHeader = config => {
  try {
    if (localStorage.jwt) {
      config.headers['Authorization'] = `Bearer ${localStorage.jwt}`
    }
    // eslint-disable-next-line
  } catch {} //without catch because is to handle errors if the user is in iframe and incognito mode active.
}

export const addLanguageHeader = config => {
  config.headers['Accept-Language'] = i18nInstance.language
}

export const handleUnauthorized = err => {
  if (err?.response?.status === httpStatuses.unauthorized) {
    if (isTokenExpired(localStorage.jwt)) {
      const merchantSlug = JSON.parse(localStorage?.context || null)?.merchantInfo?.slug
      if (merchantSlug) {
        navigateTo(`/${merchantSlug}`)
      }
    }
  }
}

axios.interceptors.response.use(
  response => {
    getTokenAndSaveInLocalStorage(response.headers)
    return response
  },
  err => {
    err.errorMessage = helpers.getErrorMessage(err)
    sendErrorToSentry(err)
    handleUnauthorized(err)
    return Promise.reject(err)
  }
)

axios.interceptors.request.use(config => {
  addJwtToAuthorizationHeader(config)
  addLanguageHeader(config)
  return config
})
